import { render, staticRenderFns } from "./MyContacts.vue?vue&type=template&id=05e97d09&"
import script from "./MyContacts.vue?vue&type=script&lang=js&"
export * from "./MyContacts.vue?vue&type=script&lang=js&"
import style0 from "./MyContacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports